export default {
  id: 'review',
  title: 'Timesheet Review',
  category: 'Manager',
  summary: 'Review, approve, reject, or remind employees about submitted timesheets.',
  overview: 'Timesheet Review is the manager queue for employee timesheets that need attention. Metrics highlight overdue, pending approval, rejection-requested, and rejected items.',
  howItWorks: [
    'Employees submit timesheets; they appear in your review queue.',
    'Open a timesheet detail to inspect hours by day and charge code.',
    'Approving finalizes the timesheet for payroll and billing use.',
    'Rejecting returns it to the employee with a reason so they can correct and resubmit.',
    'Employees may request rejection on an already submitted or approved timesheet; those appear as rejection-requested items.'
  ],
  actions: [
    {
      name: 'Filter by employee',
      description: 'Narrows the queue to a specific person.'
    },
    {
      name: 'Open timesheet detail',
      description: 'Shows the full timesheet so you can verify hours before acting.'
    },
    {
      name: 'Approve',
      description: 'Marks the timesheet approved. The employee can no longer edit unless they request rejection and you unlock it.'
    },
    {
      name: 'Reject',
      description: 'Returns the timesheet to the employee with a rejection reason. Status becomes Rejected and editing is unlocked for them.'
    },
    {
      name: 'Remind',
      description: 'Sends a reminder to employees who still need to submit or correct their timesheet.'
    }
  ],
  tips: [
    'Check rejection-requested items promptly — employees are blocked until you act.',
    'Use queue metrics to prioritize overdue submissions first.'
  ],
  related: ['timesheet', 'employees']
};



// WEBPACK FOOTER //
// ./client/help/content/review.js